import React, { useState, useEffect } from 'react';
import config from '../config';

function TrialBanner() {
  const [billing, setBilling] = useState(null);

  useEffect(() => {
    const userData = sessionStorage.getItem('user');
    if (!userData) return;

    const user = JSON.parse(userData);
    const orgId = user.organization_id;

    fetch(`${config.API_URL}/organizations/${orgId}/billing-status`)
      .then(res => res.json())
      .then(data => setBilling(data))
      .catch(err => console.error('Failed to load billing status', err));
  }, []);

  // Don't show anything while loading
  if (!billing) return null;

  // Suspended — applies regardless of plan type (trial or paid)
  if (billing.status === 'suspended') {
    return (
      <div style={{
        backgroundColor: '#7f1d1d',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '14px'
      }}>
        🚫 This account has been suspended. You can still view your data, but changes are disabled. Contact us to restore access.
      </div>
    );
  }

  // Everything below only applies to trial orgs
  if (billing.plan_type !== 'trial') return null;

  // Read-only / expired — urgent blocking banner
  if (billing.status === 'read_only') {
    return (
      <div style={{
        backgroundColor: '#dc2626',
        color: 'white',
        padding: '12px 20px',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '14px'
      }}>
        ⚠️ Your trial has expired. You can still view your data, but changes are disabled. Contact us to upgrade your plan.
      </div>
    );
  }

  // Active trial — show days remaining + device usage
  const urgent = billing.days_remaining <= 2;
  const warning = billing.days_remaining <= 7;

  const bgColor = urgent ? '#dc2626' : warning ? '#d97706' : '#1e3a8a';

  return (
    <div style={{
      backgroundColor: bgColor,
      color: 'white',
      padding: '10px 20px',
      textAlign: 'center',
      fontSize: '14px'
    }}>
      Trial — {billing.days_remaining} day{billing.days_remaining === 1 ? '' : 's'} remaining ·{' '}
      {billing.device_count}/{billing.device_limit} devices used
    </div>
  );
}

export default TrialBanner;